import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PageLoader: React.FC<{ onDone: () => void }> = ({ onDone }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate loading progress
    const steps = [20, 45, 70, 90, 100];
    let i = 0;
    const tick = () => {
      if (i < steps.length) {
        setProgress(steps[i]);
        i++;
        setTimeout(tick, i === steps.length ? 200 : 160);
      } else {
        setTimeout(onDone, 150);
      }
    };
    setTimeout(tick, 80);
  }, [onDone]);

  return (
    <motion.div
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-cream-50"
    >
      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col items-center mb-10"
      >
        <img
          src="/assets/Logo_EAM.png"
          alt="Eudora Aromas Madagascar"
          className="w-24 h-24 object-contain mb-4"
          onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
        />
        <h1 className="font-display text-2xl font-bold text-coffee-200 tracking-wide">
          Eudora Aromas
        </h1>
        <p className="text-coffee-100 text-sm mt-1">Madagascar</p>
      </motion.div>

      {/* Progress bar */}
      <div className="w-48 h-1.5 bg-cream-200 rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-forest-200 rounded-full"
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        />
      </div>
    </motion.div>
  );
};

export default PageLoader;
